enum WorkOrderStatus {
  None = "None",
  PendingDispatch = "PendingDispatch",
  DispatchedPendingAcceptance = "DispatchedPendingAcceptance",
  PendingAcceptance = "PendingAcceptance",
  Declined = "Declined",
  NotAvailableAnymore = "NotAvailableAnymore",
  Cancelled = "Cancelled",
  AcceptedPendingSchedule = "AcceptedPendingSchedule",
  Scheduled = "Scheduled",
  OnSite = "OnSite",
  WorkCompletePendingInvoice = "WorkCompletePendingInvoice",
  PendingValidation = "PendingValidation",
  PendingInvoiceApproval = "PendingInvoiceApproval",
  PendingPayment = "PendingPayment",
  ServiceComplete = "ServiceComplete",
  Paid = "Paid",
  DneRequest = "DneRequest",
  DneApproved = "DneApproved",
  PendingProposal = "PendingProposal",
  ProposalReceived = "ProposalReceived",
  PendingProposalApproval = "PendingProposalApproval",
  ProposalDeclined = "ProposalDeclined",
  ReturnTripNeeded = "ReturnTripNeeded",
  WaitingForParts = "WaitingForParts",
  FollowupNeeded = "FollowupNeeded",
  OnSiteDneIncreaseNeeded = "OnSiteDneIncreaseNeeded",
  OnSiteDneIncreaseApproved = "OnSiteDneIncreaseApproved",
  InvoiceWorkDisputed = "InvoiceWorkDisputed", // Invoice/Work disputed
}

export default WorkOrderStatus;
